import BaseEventModel from './base-event-model';

/** Represents a data model of the "Checkout Start" event. */
export class CheckoutStart extends BaseEventModel {
  constructor(
    public readonly timestamp: number,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly merchantId: string,
    public readonly shopperCountryCode: string,
    public readonly category: string,
    public readonly cdn: string,
    public readonly checkoutToken: string,
    public userAgent?: string,
    public utmSource?: string,
    public utmMedium?: string,
    public utmCampaign?: string,
    public utmTerm?: string,
    public utmContent?: string,
    public utmAdSet?: string,
    public borderfreeProperties?: object,
    public isConsentGranted?: boolean,
  ) {
    super('Checkout Start', timestamp, clientId, sessionId, merchantId, shopperCountryCode, category, cdn);
  }
}
